import { Group, Tab, Type, Role } from '../const';

/**
 * @function makeAppGroups
 * @param { array } apps
 * @param { array } roleGroups
 * @returns { array }
 */
function makeAppGroups(apps, roleGroups) {
	const newApps = [];

	for (let i = 0; i < apps.length; i++) {
		let newApp = { appId: apps[i].id, appName: apps[i].name, groups: [] };
		for (let j = 0; j < roleGroups.length; j++) {
			if (apps[i].id === roleGroups[j].appId) {
				let newGroup = {
					[Group.Id]: roleGroups[j].id,
					[Group.Name]: roleGroups[j].name,
					[Group.Desc]: roleGroups[j].desc,
					[Group.Tabs]: [],
					[Group.Roles]: [],
				};
				newApp.groups.push(newGroup);
			}
		}
		newApps.push(newApp);
	}
	return newApps;
}

/**
 * @function makeTabs
 * @param { array } apps
 * @param { array } links
 * @param { array } cantabs
 * @returns { array }
 */
function makeTabs(apps, links, cantabs) {
	const newApps = Array.from(apps);

	for (let a = 0; a < newApps.length; a++) {
		for (let b = 0; b < newApps[a].groups.length; b++) {
			for (let c = 0; c < links.length; c++) {
				if (newApps[a].groups[b][Group.Id] === links[c].roleGroupId) {
					for (let d = 0; d < cantabs.length; d++) {
						if (
							links[c].tabId === cantabs[d].id &&
							links[c].submenuId === '0'
						) {
							let newTab = {
								[Tab.GroupId]: newApps[a].groups[b][Group.Id],
								[Tab.Id]: cantabs[d].id,
								[Tab.Name]: cantabs[d].name,
								[Tab.Url]: cantabs[d].url,
								[Tab.Desc]: cantabs[d].desc,
								[Tab.Order]: links[c].order,
								[Tab.Subtabs]: [],
								[Tab.Checked]: false,
								[Tab.SubtabId]: links[c].submenuId,
								[Tab.Open]: false,
							};
							newApps[a].groups[b][Type.Tabs].push(newTab);
						}
					}
				}
			}
		}
	}
	return newApps;
}

/**
 * @function makeRoles
 * @param { array } apps
 * @param { array } roles
 * @param { array } links
 * @returns { array }
 */
function makeRoles(apps, roles, links) {
	const newApps = Array.from(apps);

	for (let a = 0; a < newApps.length; a++) {
		for (let b = 0; b < newApps[a].groups.length; b++) {
			for (let c = 0; c < links.length; c++) {
				if (newApps[a].groups[b][Group.Id] === links[c].groupId) {
					for (let d = 0; d < roles.length; d++) {
						if (links[c].roleId === roles[d].id) {
							let newRole = {
								[Role.GroupId]: newApps[a].groups[b][Group.Id],
								[Role.Id]: roles[d].id,
								[Role.Name]: roles[d].name,
								[Role.Desc]: roles[d].desc,
								[Role.Type]: roles[d].type,
								[Role.Checked]: false,
							};
							newApps[a].groups[b].roles.push(newRole);
						}
					}
				}
			}
		}
	}
	return newApps;
}

/**
 * @function makeSubtabs
 * @param { array } apps
 * @param { array } links
 * @param { array } cantabs
 * @returns { array }
 */
function makeSubtabs(apps, links, cantabs) {
	const newApps = Array.from(apps);

	for (let a = 0; a < newApps.length; a++) {
		for (let b = 0; b < newApps[a].groups.length; b++) {
			for (let c = 0; c < newApps[a].groups[b].tabs.length; c++) {
				if (newApps[a].groups[b].tabs[c][Tab.Url] === 'Sub-menu') {
					for (let d = 0; d < links.length; d++) {
						if (
							newApps[a].groups[b].tabs[c][Tab.Id] ===
							links[d].submenuId
						) {
							for (let e = 0; e < cantabs.length; e++) {
								if (
									links[d].tabId === cantabs[e].id &&
									links[d].roleGroupId ===
										newApps[a].groups[b][Group.Id]
								) {
									let newSubtab = {
										[Tab.GroupId]: links[d].roleGroupId,
										[Tab.Id]: cantabs[e].id,
										[Tab.Name]: cantabs[e].name,
										[Tab.Url]: cantabs[e].url,
										[Tab.Desc]: cantabs[e].desc,
										[Tab.Order]: links[d].order,
										[Tab.SubtabId]: links[d].submenuId,
										[Tab.Checked]: false,
									};
									newApps[a].groups[b].tabs[c][
										Type.Subtabs
									].push(newSubtab);
									break;
								}
							}
						}
					}
				}
			}
		}
	}
	return newApps;
}

/**
 * @function populateMenus
 * @param { object } res
 * @param { array } roles
 * @returns { array }
 */
function populateMenus(res, roles) {
	const { dbApps, dbRoleGroups, dbMenus, dbTabs, dbLinkedRoles } = res;

	const _apps = makeAppGroups(dbApps, dbRoleGroups, dbMenus, dbTabs);
	const __apps = makeTabs(_apps, dbMenus, dbTabs);
	const ___apps = makeRoles(__apps, roles, dbLinkedRoles);
	const apps = makeSubtabs(___apps, dbMenus, dbTabs);

	return apps;
}

export default populateMenus;
